import { render, staticRenderFns } from "./jsonPrettyTable.vue?vue&type=template&id=404318c8"
import script from "./jsonPrettyTable.vue?vue&type=script&lang=js"
export * from "./jsonPrettyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports